module.exports = __webpack_public_path__ + "img/alert.68d5b2f7.svg";